import { Controller } from "@hotwired/stimulus"

// Handles dismissing flash messages
// Usage: <div data-controller="flash">
//          <button data-action="flash#dismiss">Close</button>
//        </div>
export default class extends Controller {
  dismiss() {
    this.element.remove()
  }
}
